import { render, staticRenderFns } from "./Bulk.vue?vue&type=template&id=7d55c5a0&scoped=true&"
import script from "./Bulk.vue?vue&type=script&lang=js&"
export * from "./Bulk.vue?vue&type=script&lang=js&"
import style0 from "./Bulk.vue?vue&type=style&index=0&id=7d55c5a0&prod&lang=less&"
import style1 from "./Bulk.vue?vue&type=style&index=1&id=7d55c5a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d55c5a0",
  null
  
)

export default component.exports